import { gql } from "@apollo/client"; // saveVisitaDatoClinico.js


const SAVE_VISITA_DATO_CLINICO = gql`
  mutation saveVisitaDatoClinico($input: AddVisitaDatoClinicoInput!) {
    saveVisitaDatoClinico(input: $input) {
      idVisita
      idVisitaDatoClinico
    }
  }
`;

export default SAVE_VISITA_DATO_CLINICO;

export const adaptAddVisitaDatoClinicoInput = (data, alergiaOtrosId) => ({
  idVisitaDatoClinico: data?.idVisitaDatoClinico,
  listaDiagnostico: data?.listaDiagnostico?.map((d) => ({ idDiagnostico: d.codigo, idItemDiagnostico: d.codigoItem })),
  oncologico: !!data?.oncologico,
  pesoActual: data?.pesoActual,
  talla: data?.talla,
  justificacionVariacion: data?.justificacionVariacion,
  idComboRIValorTiempo: data?.idComboRIValorTiempo,
  pesoHabitual: data?.pesoHabitual,
  idComboRIValorEvaluado: data?.idComboRIValorEvaluado,
  iMC: data?.iMC,
  perdidaPeso: data?.perdidaPeso,
  idComboRIValorGradoDesnutricion: data?.idComboRIValorGradoDesnutricion,
  idComboRIValorDiagnostico: data?.idComboRIValorDiagnostico,
  idComboRIValorSoporte: data?.idComboRIValorSoporte,
  zScoreTalla: data?.pedZScoreTalla,
  zScorePeso: data?.pedZScorePeso,
  zScoreIMC: data?.pedZScoreIMC,
  idComboRIValorJustificacion: data?.idComboRIValorJustificacion,
  causaJustificacion: data?.causaJustificacion,
  idComboRIValorFase: data?.idComboRIValorFase,
  justificacionModificacion: data?.justificacionModificacionDatosClinicos,
  // idPaciente: data?.idPaciente,
  listaAlergia: data?.alergiasDatosClinicos?.map((id) => ({
    idAlergia: id,
    descripcionAlergiaOtro: id === alergiaOtrosId ? data?.descripcionAlergiaOtro : ''
  })) || [],
  idVisita: data?.idVisita,
});